import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ModifyShopAction = "MODIFY_SHOP";
const SaveShopAction = "SAVE_SHOP";
const ListShopsAction = "LIST_SHOPS";
const ListMerchantsAction = "LIST_MERCHANTS";
const Waiting = "WAITNG_SHOPS";

const initialState = {
    mlist: [],
    list: [],
    nowWainting: false,
    editing: null
};
export const actionCreators = {
    /**
     * 選択可能な加盟店一覧を取得します。
     */
    listMerchants: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/selectable_list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const mlist = await response.json();
                dispatch({ type: ListMerchantsAction, mlist });
                return mlist;
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 店舗一覧を取得します。
     */
    listShops: (token, merchantId) => async (dispatch) => {
        var routeurl = `api/user/shops/list`;

        if (merchantId != null) {
            routeurl += `?id=${merchantId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListShopsAction, list });
                    return list;
                } else {
                    throw new Error(resp.error_message || '店舗一覧取得に失敗しました。');
                }
            } else {
                throw new Error('店舗一覧取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 店舗情報を編集します。
     */
    modifyShop: (shop) => async (dispatch) => {
        dispatch({ type: ModifyShopAction, shop, nowWainting: false });
    },

    /**
     * 編集を保存します。
     * 店舗情報登録時は、内包しているアカウント情報も併せて登録
     */
    save: (token, shop) => async (dispatch) => {
        var routeurl = `api/user/shops`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(shop)
            })

            var addNew = false;

            // IDがまだないものは新規登録とみなす
            if (shop.id == null || shop.id == '') {

                addNew = true;
            }

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    dispatch({ type: SaveShopAction, shop: resp.result, addNew });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '店舗情報の登録に失敗しました。');
                }
            } else {
                throw new Error('店舗情報の登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, shopId) => async (dispatch) => {
        var routeurl = `api/user/shops/edit`;

        if (shopId != null) {
            routeurl += `?id=${shopId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const shop = resp.result;
                    dispatch({ type: ModifyShopAction, shop });
                    return shop;
                } else {
                    throw new Error(resp.error_message || '店舗情報取得に失敗しました。');
                }
            } else {
                throw new Error('店舗情報取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * プロフィール用のモデルをロードします。
     */
    loadProfileModel: (token, shopId, accountId) => async (dispatch) => {
        var routeurl = `api/user/shops/profile`;

        if (shopId != null) {
            routeurl += `?id=${shopId}`;
        }
        if (accountId != null) {
            routeurl += `&account_id=${accountId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const shop = resp.result;
                    dispatch({ type: ModifyShopAction, shop });
                    return shop;
                } else {
                    throw new Error(resp.error_message || '店舗情報取得に失敗しました。');
                }
            } else {
                throw new Error('店舗情報取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 店舗情報を設定します。
     */
    setShopInfo: (shop) => async (dispatch) => {
        dispatch({ type: ModifyShopAction, shop, nowWainting: false });
    },

    /**
     * 店舗の有効化/無効化。
     */
    setEnable: (token, shop, enabled) => async (dispatch) => {
        var routeurl = `api/user/shops`;

        dispatch({ type: Waiting, nowWainting: true });

        // フラグをセット(true:有効化、false:無効化)
        if (enabled) {
            // 有効化：無効フラグをfalse
            shop.is_disabled = false;
        } else {
            // 無効化：無効フラグをtrue
            shop.is_disabled = true;
        }

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(shop)
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    dispatch({ type: SaveShopAction, shop: resp.result });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '登録に失敗しました。');
                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 店舗情報ファイルをアップロードします。
     */
    upload: (token, merchantId, csvJson) => async (dispatch) => {
        var routeurl = `api/user/shops/upload`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            var param = {
                'merchant_id': merchantId,
                'data': csvJson
            }

            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(param)
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListShopsAction, list });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '店舗/端末情報のアップロードに失敗しました。');
                }
            } else {
                throw new Error('店舗/端末情報のアップロードに失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyShopAction) {
        return {
            ...state,
            editing: action.shop,
            nowWainting: action.nowWainting
        };
    }
    // 加盟店リスト
    if (action.type === ListMerchantsAction) {
        return {
            ...state,
            mlist: action.mlist,
            nowWainting: action.nowWainting
        };
    }
    // 店舗リスト
    if (action.type === ListShopsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === SaveShopAction) {

        if (action.addNew) {
            // 店舗の新規登録時の場合はリストに追加
            state.list.push(action.shop);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.list.findIndex((o) => o.id == action.shop.id);
            state.list[idx] = action.shop;
        }

        return {
            ...state,
            editing: action.shop
        };
    }
    return state;
}